var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleFullColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.844 6.433H15.2V6.4H8v3.2h4.521A4.798 4.798 0 013.2 8 4.8 4.8 0 018 3.2c1.224 0 2.337.462 3.184 1.216l2.263-2.263A7.963 7.963 0 008 0a8 8 0 107.844 6.433z",
    fill: "#FFC107"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.922 4.276l2.629 1.928A4.798 4.798 0 018 3.2c1.224 0 2.337.462 3.184 1.216l2.263-2.263A7.963 7.963 0 008 0 7.995 7.995 0 00.922 4.276z",
    fill: "#FF3D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16c2.066 0 3.944-.79 5.364-2.077l-2.476-2.095A4.764 4.764 0 018 12.8a4.798 4.798 0 01-4.513-3.178l-2.609 2.01A7.994 7.994 0 008 16z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.844 6.433H15.2V6.4H8v3.2h4.521a4.816 4.816 0 01-1.635 2.228h.002l2.476 2.095C13.188 14.082 16 12 16 8c0-.537-.055-1.06-.156-1.567z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleFullColor);
export default __webpack_public_path__ + "static/media/google-full-color.47f09b8017f857453ae7fe17727dbf6d.svg";
export { ForwardRef as ReactComponent };